import { Injectable } from '@angular/core';
import { MenuTree, userMenuAccess } from '../auth/store/auth.model';

@Injectable({
  providedIn: 'root'
})
export class HelperServiceService {

  constructor() { }

  getImageFileAndUrl(event: Event): { image: File | null; imageUrl: string | null } {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const image = input.files[0];
      const imageUrl = URL.createObjectURL(image);
      return { image, imageUrl };
    }
    return { image: null, imageUrl: null };
  }

  toggleIsEditingAtLevel(
    structure: any[],
    lvl: number,
    indices: { parentIndex?: number; childIndex?: number; grandChildIndex?: number },
    nodeType: number,
    contentIndex?: number,
    toggleType: 'edit' | 'visible' = 'edit'
  ): any[] {
    const updatedStructure = [...structure];

    const { parentIndex, childIndex, grandChildIndex } = indices;

    const getNode = () => {
      if (lvl === 1) return updatedStructure[parentIndex!];
      if (lvl === 2) return updatedStructure[parentIndex!]?.child?.[childIndex!];
      if (lvl === 3) return updatedStructure[parentIndex!]?.child?.[childIndex!]?.grandChild?.[grandChildIndex!];
    };

    const setNode = (newNode: any) => {
      if (lvl === 1) {
        updatedStructure[parentIndex!] = newNode;
      } else if (lvl === 2) {
        const parent = { ...updatedStructure[parentIndex!] };
        const updatedChild = [...parent.child];
        updatedChild[childIndex!] = newNode;
        parent.child = updatedChild;
        updatedStructure[parentIndex!] = parent;
      } else if (lvl === 3) {
        const parent = { ...updatedStructure[parentIndex!] };
        const child = { ...parent.child[childIndex!] };
        const updatedGrandChild = [...child.grandChild];
        updatedGrandChild[grandChildIndex!] = newNode;
        child.grandChild = updatedGrandChild;
        parent.child = [...parent.child];
        parent.child[childIndex!] = child;
        updatedStructure[parentIndex!] = parent;
      }
    };

    const node = getNode();
    if (!node) return updatedStructure;

    if (nodeType === 1) {
      if (toggleType === 'edit') {
        setNode({ ...node, isEditing: !node.isEditing });
        // node.isEditing = !node.isEditing;
      } else if (toggleType === 'visible') {
        setNode({ ...node, isOpen: !node.isOpen });
        // node.isOpen = !node.isOpen;
      }
    } else if (nodeType === 2 && contentIndex != null) {
      const maps = [...node.structure_maps];
      const map = maps[contentIndex];
      if (map?.action_type === 'video') {
        maps[contentIndex] = {
          ...map,
          video: {
            ...map.video,
            isEditing: !map.video?.isEditing,
          },
        };
        setNode({ ...node, structure_maps: maps });
      }
    }

    return updatedStructure;
  }

  TimeOptions() {
    const TIME_OPTIONS: string[] = Array.from({ length: 96 }, (_, i) => {
      const hours = Math.floor(i / 4).toString().padStart(2, '0');
      const minutes = ((i % 4) * 15).toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    });
    return TIME_OPTIONS;
  }

  buildMenuTree(menuList: any[]): userMenuAccess {
    console.log('menuList', menuList);



    if (!Array.isArray(menuList)) {
      console.error("menuList is not an array:", menuList);
      return { menu_tree: [], slug_array: {} };
    }
    const map = new Map<number, MenuTree>();
    const tree: MenuTree[] = [];
    const slugGroups: { [parent_slug: string]: string[] } = {};

    // 1. First pass: convert to MenuTree and group slugs by parent
    for (const menu of menuList) {

      let formateSlug = menu.slug.replace(/-/g, '_').replace(/\s/g, '_').toLowerCase();

      const menuNode: MenuTree = {
        id: menu.id,
        menu_name: menu.menu_name,
        menu_slug: formateSlug,
        url: menu.url,
        sequence: menu.sequence_no,
        sub_menus: null
      };

      // Group slugs by parent menu
      if (menu.parent_menu_id === null) {
        // Root menu - group under "root"
        if (!slugGroups['root']) {
          slugGroups['root'] = [];
        }
        slugGroups['root'].push(formateSlug);
      } else {
        // Child menu - will be grouped under parent in second pass
        // For now, collect all slugs including children
        if (!slugGroups['all']) {
          slugGroups['all'] = [];
        }
        slugGroups['all'].push(formateSlug);
      }

      // Handle nested slugs in uac_items (recursive)
      if (Array.isArray(menu.uac_items)) {
        for (const uac of menu.uac_items) {
          this.collectUacSlugsGrouped(uac, formateSlug, slugGroups);
        }
      }

      map.set(menu.id, menuNode);
    }

    // 2. Second pass: assign children to their parents and group child slugs
    for (const menu of menuList) {
      const menuNode = map.get(menu.id)!;

      if (menu.parent_menu_id === null) {
        tree.push(menuNode);
      } else {
        const parent = map.get(menu.parent_menu_id);
        if (parent) {
          if (!parent.sub_menus) parent.sub_menus = [];
          parent.sub_menus.push(menuNode);

          // Group child slug under parent's slug
          let formateSlug = menu.slug.replace(/-/g, '_').replace(/\s/g, '_').toLowerCase();
          if (!slugGroups[parent.menu_slug]) {
            slugGroups[parent.menu_slug] = [];
          }
          slugGroups[parent.menu_slug].push(formateSlug);
        }
      }
    }

    // Remove temporary 'all' group if it exists
    delete slugGroups['all'];

    return {
      menu_tree: tree,
      slug_array: slugGroups
    };
  }

  // 🔁 Helper to recursively collect slugs from uac_items
  private collectUacSlugs(item: any, slugs: string[]) {
    if (item.slug) {
      slugs.push(item.slug);
    }

    if (Array.isArray(item.children)) {
      for (const child of item.children) {
        this.collectUacSlugs(child, slugs);
      }
    }
  }

  // 🔁 Helper to recursively collect slugs from uac_items and group by parent
  private collectUacSlugsGrouped(item: any, parentSlug: string, slugGroups: { [parent_slug: string]: string[] }) {
    if (item.slug) {
      if (!slugGroups[parentSlug]) {
        slugGroups[parentSlug] = [];
      }
      slugGroups[parentSlug].push(item.slug);
    }

    if (Array.isArray(item.children)) {
      for (const child of item.children) {
        this.collectUacSlugsGrouped(child, parentSlug, slugGroups);
      }
    }
  }


  // seraching for department, class, batch in hierarchy data
  searchHierarchy(data: any[], query: string) {
  if (!query) return data;

  query = query.toLowerCase();

  return data
    .map(department => {
      // Case 1: department match → return full department
      if (department.department_name.toLowerCase().includes(query)) {
        return department;
      }

      // Case 2: class or batch match
      const filteredClasses = (department.classes || [])
        .map((cls:any) => {
          // If class matches → keep class with all batches
          if (cls.class_name.toLowerCase().includes(query)) {
            return cls;
          }

          // Otherwise check batches
          const filteredBatches = (cls.batches || []).filter((batch:any) =>
            batch.batch_name.toLowerCase().includes(query)
          );

          if (filteredBatches.length > 0) {
            return {
              ...cls,
              batches: filteredBatches
            };
          }

          return null;
        })
        .filter((cls: any) => cls !== null);

      if (filteredClasses.length > 0) {
        return {
          ...department,
          classes: filteredClasses
        };
      }

      return null;
    })
    .filter(department => department !== null);
}






}
